export default {
  open_standalone: 'Abertos',
  closed_standalone: 'Fechados',

  open: 'Abertos',
  closed: 'Fechados',
  opening: 'Abrimos',
  closing: 'Fechamos',
  yes_we_are: 'Sim, estamos',
  sorry_we_are: 'Desculpe, estamos',
  twentyfourseven: '24/7',
  closing_tomorrow: 'Fechamos amanhã',
  opening_tomorrow: 'Abrimos amanhã',
  at_x: 'às %x%',
  closing_x: 'Fechamos %x%',
  opening_x: 'Abrimos %x%',

  monday: 'Segunda-feira',
  tuesday: 'Terça-feira',
  wednesday: 'Quarta-feira',
  thursday: 'Quinta-feira',
  friday: 'Sexta-feira',
  saturday: 'Sábado',
  sunday: 'Domingo',

  businessHours: 'Horário Comercial'
};



// WEBPACK FOOTER //
// ./src/commons/translations/pt.js